import { Extent } from "ol/extent";
import { extract_tripData_forHTML, getTrip_cachedForm } from "../../util/general_util";
import { Campground_Data, copilot_err_resp, copilot_success_resp, POI_Data, Trip_Cluster_v2, Trip_cookieFormat, Trip_cookieFormat_v2, Trip_sendUpdateGetDirectionsAndHTMLFormat_v2, Trip_v2 } from "../../util/tripPlanner_types";
import { Trip_ReqFields_E2E, Trip_ReqFields_Regional, Trip_ReqFields_stopByStop } from "../../util/type_defs";
import { send_getAPItoken } from "../../util/search_api";

export const addStop_noLoc = (stop_name:string):Promise<Trip_v2> => {
	return new Promise<Trip_v2>((resolve,reject) => {
		$.ajax({
			type: "post",
			url: "/addStop_noLoc",
			data: JSON.stringify({stop_name:stop_name}),
			contentType: "application/json",
			dataType: "json",
			success: (data) => {
				resolve(data);
			},
			error: (xhr,errStr,exc)=>{
				reject(new Error(xhr.responseText));
			}
		});
	});
};

export const send_copilot_req = async (userInput:string, trip:Trip_v2) => {
	let success:boolean = false;
	let errMsg:string;
	let response:copilot_success_resp|copilot_err_resp;

	const apiToken:string = await send_getAPItoken();

	let tripStops:{name:string,identifier:string}[] = [];
	if (trip != undefined && trip != null && trip.legs != null) {
	for (let i:number = 0; i < trip.legs.length; i++) {
			for (let j:number = 0; j < trip.legs[i].clusters.length; j++) {
				tripStops.push({
					name: trip.legs[i].clusters[j].clusterTitle,
					identifier: `${i}-${j}`
				})
			};
		};
	};

	await $.ajax({
		type: "post",
		url: "/copilot",
		data: JSON.stringify({
			userInput: userInput,
			tripStops:tripStops,
			history: window.copilotHistory
		}),
		headers: {
			"Authorization": `Bearer ${apiToken}`
		},
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			response = data;
			success = true;
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<copilot_success_resp|copilot_err_resp>((resolve,reject) => {
		if (success) resolve(response)
		else reject(Error(errMsg));
	});
};

export const get_poiOnRoutePinPopup = async (poi:any) => {
	let success:boolean = false;
	let errMsg:string;
	let responseHTML:string;

	await $.ajax({
		type: "post",
		url: "/getPoiOnRoutePinPopup",
		contentType: "application/json",
		data: JSON.stringify(poi),
		dataType: "html",
		success: (data)=>{
			success=true;
			responseHTML=data;
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};

export const send_getPoiOnRouteControl = async () => {
	let success:boolean = false;
	let errMsg:string;
	let responseHTML:string;

	await $.ajax({
		type: "get",
		url: "/getPoiOnRouteControl",
		dataType: "html",
		success: (data)=>{
			success=true;
			responseHTML=data;
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};

export const send_getWalmartOnRouteControl = async () => {
	let success:boolean = false;
	let errMsg:string;
	let responseHTML:string;

	await $.ajax({
		type: "get",
		url: "/getWalmartOnRouteControl",
		dataType: "html",
		success: (data)=>{
			success=true;
			responseHTML=data;
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};

export const send_addPOI_asStop = async (trip:Trip_v2,poiID:number, closestStopsIndices:Array<{legIndex:number,stopIndex:number}> ) => {
	let response:Trip_v2;
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/addPoiAsStop",
		data: JSON.stringify({
			poiID:poiID,
			closestStopsIndices:closestStopsIndices,
			trip: getTrip_cachedForm(trip)
		}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			response = data;
			success = true;
		},
		error: (xhr, errStr, exc)=>{errMsg = errStr;}
	});

	return new Promise<Trip_v2>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg))
	});
};

export const send_getTripFromSpreadsheet = async (file:File) => {
	let response:Trip_v2;
	let success:boolean = false;
	let errMsg:string;

	const formData = new FormData();
	formData.append('file', file);
	await $.ajax({
		type: "post",
		url: "/getTripFromSpreadsheet",
		data: formData,
		processData: false,
		contentType: false,
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr, errStr, exc)=>{errMsg = errStr;}
	})

	return new Promise<Trip_v2>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg))
	});
};

async function allInOneTrip_streamResp(apiToken:string, query:string) {
	return new Promise<string>((resolve,reject) => {
		const source = new EventSource(`/ai_get_trip?token=${apiToken}&query=${query}`);
		try {

			let buffer:string = "";
			let responseFull:string = "";
			const myRegex:RegExp = /{(?:(?!{"title":).)*?}/g;
			source.onmessage = function(event) {
				$("#iterResultsDisp").removeClass("d-none");
				responseFull += event.data;

				let stops_strs:Array<string>|null = responseFull.match(myRegex);
				let html:string = "";
				if (stops_strs != null) {

					for (let i:number = 0; i < stops_strs.length; i++) {
						let stop:{title:string,itinerary?:string} = JSON.parse(stops_strs[i]);
						html += "<div class='d-flex flex-column w-100'>"
						html += "<div class='stopCard no-hover lockedStop d-flex flex-row justify-content-between p-3 card align-items-center mb-0 stopByUser w-100'>"
						html += `<h4 class="mb-0" stopTitle="">${stop.title}</h4>`;
						html += "</div>"
						if (stop.itinerary != undefined) html += stop.itinerary.replace("<ul>","<ul class='border rounded-bottom'>");
						html += "</div>"
					};
				}
				$("#iterResultsStopsDisp").html(html)
			};
			source.addEventListener("end", function(e) {
				source.close();
				resolve(responseFull);
			});
			source.onerror = (event:Event) => {
				source.close();
				reject(event)
			};
		} catch (error:any) {
			source.close();
			reject(error);
		}
	});
};

export const send_AIsearchAllInOne = async (apiToken:string, query:string) => {
	let response:Array<any>|null = null;
	let success:boolean = false;
	let errMsg:string;

	let response_str:string;

	if (query.trim().length > 0) {
		await allInOneTrip_streamResp(apiToken, query).then(result => {
			success = true;
			response_str = result;
			response = JSON.parse(response_str);
		}).catch(e => {
			errMsg = e.toString();
		});
	} else {
		errMsg = "query is empty";
	};

	return new Promise<Array<any>>((resolve, reject) => {
		if (success && response != null) resolve(response);
		else reject(Error(errMsg));
	})
};

export const send_tripPlanAllInOneSearch = async (stops:Array<any>,searchQuery:string) => {
	let trip:Trip_v2|null=null;
	let errMsg:string;
	await $.ajax({
		type:"post",
		url:"/tripPlanner_autoGenTrip",
		data: JSON.stringify({stops: stops,searchQuery:searchQuery}),
		contentType: 'application/json',
		dataType:'json',
		success: (data) => {
			trip = data as Trip_v2;
			if (trip.directions == null) {
				trip = null;
			};
		},
		error: (xhr, errStr, exc)=>{errMsg = errStr;}

	});
	return new Promise<Trip_v2>((resolve,reject) => {
		if (trip != null) resolve(trip);
		else reject(Error(errMsg));
	});
}

export const send_getGenieMatches = async (cluster:Trip_Cluster_v2) => {
	let response:Array<{campID:number, genieMatch:number}>;
	let errMsg:string;
	let success:boolean = false;

	await $.ajax({
		"type": "post",
		"url": "/getGenieMatches_forCluster",
		data: JSON.stringify(cluster.altCampIDs),
		"contentType": "application/json",
		"dataType": "json",
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr, errStr, exc) => {
			errMsg = errStr;
		}
	});

	return new Promise<Array<{campID:number, genieMatch:number}>>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const get_tripNotes = async ():Promise<any> => {
	return new Promise<any>((resolve, reject) => {
		$.ajax({
			type: "get",
			url: "/tripNotes",
			dataType: "json",
			success: (data) => {resolve(data)},
			error: (xhr, errStr, exc) => {reject(new Error(errStr))}
		});
	});
}

export const send_updateTripNotes= async (notes:Array<{legIndex:number,stopIndex:number,notes:string}>) => {
	await $.ajax({
		"type": "post",
		"url": "/updateTripNotes",
		"data": JSON.stringify(notes),
		"contentType": "application/json"
	});
};

export const send_updateTripItinerary = async (tripItinerary:string) => {
	await $.ajax({
		"type": "post",
		"url": "/updateTripItinerary",
		"data": JSON.stringify({itinerary: tripItinerary}),
		contentType: "application/json"
	})
};



export const send_updateLockedStops = async (action:"lock"|"unlock", legIndex:number, stopIndex:number) => {
	await $.ajax({
		"type": "post",
		"url": "/updateLockedStops",
		"data": JSON.stringify({
			action: action,
			legIndex: legIndex,
			stopIndex: stopIndex
		}),
		contentType: "application/json"
	});
};

export const send_updatePoiDate = async (legIndex:number, stopIndex:number, poiID:string, date:Date|null) => {
	await $.ajax({
		"type": "post",
		"url": "/updatePOIdate",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			poiID: poiID,
			date: date
		}),
		contentType: "application/json"
	})
};

export const send_updateStayDates = async (legIndex:number, stopIndex:number, campID:number, s_date:Date|null, numNights:number|null) => {
	await $.ajax({
		"type": "post",
		"url": "/updateStayDates",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			campID: campID,
			s_date: s_date,
			numNights: numNights
		}),
		contentType: "application/json"
	});
};

export const send_updateStopDates = async (legIndex:number, stopIndex:number, s_date:Date|null, numNights:number|null) => {
	await $.ajax({
		"type": "post",
		"url": "/updateStopDates",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			s_date: s_date,
			numNights: numNights
		}),
		contentType: "application/json"
	});
};

export const send_updateStopRadius = async (legIndex:number, stopIndex:number, radius:number) => {
	await $.ajax({
		"type": "post",
		"url": "/updateStopRadius",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			radius: radius
		}),
		contentType: "application/json"
	});
};

export const send_removeStayFromStop = async (legIndex:number, stopIndex:number, campID:number) => {
	await $.ajax({
		"type": "post",
		"url": "/removeStayFromStop",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			campID: campID
		}),
		contentType: "application/json"
	});
};

export const send_addCustomStayToStop = async (legIndex:number, stopIndex:number, campID:number, s_date:Date|null, numNights:number|null, customName:string) => {
	await $.ajax({
		"type": "post",
		"url": "/addStayToStop",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			campID: campID,
			s_date: s_date,
			numNights: numNights,
			isCustom: true,
			customName: customName
		}),
		contentType: "application/json"
	});
};

export const send_addStayToStop = async (legIndex:number, stopIndex:number, campID:number, s_date:Date|null, numNights:number|null) => {
	await $.ajax({
		"type": "post",
		"url": "/addStayToStop",
		"data": JSON.stringify({
			legIndex: legIndex,
			stopIndex: stopIndex,
			campID: campID,
			s_date: s_date,
			numNights: numNights,
			isCustom: false
		}),
		contentType: "application/json"
	});
};

export const send_updateStop_POI = async (action:"add"|"rem", legIndex:number, stopIndex:number, poiID:string) => {
	await $.ajax({
		"type": "post",
		"url": "/updateStopPOI",
		"data": JSON.stringify({
			action: action,
			legIndex: legIndex,
			stopIndex: stopIndex,
			poiID: poiID
		}),
		contentType: "application/json"
	});
};

export const get_pois_on_route = async (geometry:Array<Array<number>>,bounds:Extent, distToLine_m:number, typeIDs:number[]) => {
	let errMsg:string|null = null;
	let result:Array<POI_Data>|undefined = undefined;
	let success:boolean = false;

	await $.ajax({
		type: "post",
		url: "/getPOIs_onRoute",
		data: JSON.stringify({
			line: geometry,
			bounds:bounds,
			typeIDs: typeIDs,
			dist: distToLine_m
		}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			result = data;
		},
		error: (xhr, errStr, exc)=>{
			errMsg = errStr;
		}
	});

	return new Promise<Array<POI_Data>>((resolve, reject) => {
		if (success) resolve(result);
		else reject(Error(errMsg));
	});
};

export const get_pois_for_stop = async (typeID:number,radius:number,latitude:number, longitude:number, legIndex:number, stopIndex:number) => {
	let errMsg:string|null = null;
	let result:Array<POI_Data>|undefined = undefined;
	let success:boolean = false;

	await $.ajax({
		type: "get",
		url: `/getPOIs?type=${typeID}&r=${radius}&lat=${latitude}&lng=${longitude}&l=${legIndex}&s=${stopIndex}`,
		contentType: "application/x-www-form-urlencoded",
		dataType: "json",
		success: (data) => {
			success = true;
			result = data;
		},
		error: (xhr, errStr, exc)=>{
			errMsg = errStr;
		}
	});

	return new Promise<Array<POI_Data>>((resolve, reject) => {
		if (success) resolve(result);
		else reject(Error(errMsg));
	});
};

export const download_trip_pdf = async (trip:Trip_cookieFormat_v2,trip_dist:number,trip_duration:number,trip_dists:Array<number>,trip_durations:Array<number>) => {
	let errMsg:string = null;
	let pdf_name:string = (trip.n != null)? `AdventureGenieTrip-${trip.n}.pdf`: "AdventureGenieTrip-unnamed.pdf"

	await $.ajax({
		type: "post",
		url: "/printTrip",
		data: JSON.stringify({
			trip:trip,
			trip_dist:trip_dist,
			trip_duration:trip_duration,
			trip_dists:trip_dists,
			trip_durations:trip_durations,
			tz: Intl.DateTimeFormat().resolvedOptions().timeZone
		}),
		contentType: "application/json",
		xhrFields: {
			responseType: "blob"
		  },
		success: (data) => {
			let url:string;
			try {
				url = URL.createObjectURL(data);
				window.open(url,'_blank');
			} catch {
				url = URL.createObjectURL(data);
				let link = document.createElement("a");
				link.href = url;
				link.download = pdf_name;
				$("#exportTripSidebar").append(link);
				link.click();
			};

			$(
				[
					'<div exportlink="exportlink", onclick="this.remove()" class="d-flex gap-1">',
					'<p>If pdf does not automatically open click</p>',
					`<a href="${url}" target="_blank">here</a>`,
					'</div>'
				].join("\n")
			).insertBefore("#printTrip");
		},
		error: (xhr, errStr, exc)=>{
			errMsg = errStr;
		}
	});
};

export const download_trip_gpx = async (trip:Trip_cookieFormat_v2) => {
	let gpx_name:string = (trip.n != null)? `AdventureGenieTrip-${trip.n}.gpx`: "AdventureGenieTrip-unnamed.gpx"
	fetch("/get_trip_export_gpx", {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify(trip)
	})
	.then(response => response.blob())
	.then(data => {
		let url = URL.createObjectURL(data);
		let link = document.createElement("a");
		link.href = url;
		link.download = gpx_name;
		$("#exportTripSidebar").append(link);
		link.click();
	})
	.catch(error => {
		console.error("Error:", error);
	});
};

export function build_locations_and_camp_names(trip: Trip_v2): Array<string | {latitude: number, longitude: number}> {
	if (!trip.legs || trip.legs.length === 0) {
        console.error("No trip legs found.");
        return [];
    }

	let locations:Array<string|{latitude:number,longitude:number}> = []
	for(let i=0; i < trip.legs.length; i++){
		//loop through each leg, build out grab the waypoints, build the stoplist, create url
		for (let j=0; j < trip.legs[i].clusters.length; j++){
			let cluster:Trip_Cluster_v2 = trip.legs[i].clusters[j];
			if (trip.legs[i].clusters[j].selectedCamps.length > 0){
				for (let k=0; k < trip.legs[i].clusters[j].selectedCamps.length; k++){
					locations.push(cluster.selectedCamps[k].camp.camp_name + ", " + cluster.selectedCamps[k].camp.city + ", " + cluster.selectedCamps[k].camp.administrative_area_level_1);
				}
			}else{
				locations.push({latitude:cluster.coords.latitude, longitude:cluster.coords.longitude});
			}
		}
	}
	return locations;
};

export const download_trip_xlsx = async (trip:Trip_cookieFormat_v2,dist:number) => {
	let errMsg:string = null;
	let xlsx_name:string = (trip.n != null)? `AdventureGenieTrip-${trip.n}.xlsx`: "AdventureGenieTrip-unnamed.xlsx"


	await $.ajax({
		type: "post",
		url: "/get_trip_export_xlsx",
		data: JSON.stringify({
			trip:trip,
			dist:dist,
			tz: Intl.DateTimeFormat().resolvedOptions().timeZone
		}),
		contentType: "application/json",
		xhrFields: {
			responseType: "blob"
		  },
		success: (data) => {
			let url = URL.createObjectURL(data);
			let link = document.createElement("a");
			link.href = url;
			link.download = xlsx_name;
			$("#exportTripSidebar").append(link);
			link.click();
		},
		error: (xhr, errStr, exc)=>{
			errMsg = errStr;
		}
	});
};

/*
 * on success:
 * 	if user has Trip_old in progress: returns Trip (see util/type_defs.ts)
 *  otherwise returns str "No Trip"
 * on failure:
 *   returns either Error() with errStr or xhr from request
 */
export const send_getCurTrip = async (tripCookie:Trip_cookieFormat|string) => {
	let trip:Trip_v2;
	let errMsg:string = null;
	let failSilently:boolean = false;
	let data:string;

	if (tripCookie instanceof Object) {
		/* this is to handle old cookies
		 * new trips should have string id for cookie
		 */
		data = JSON.stringify(tripCookie);
	} else {
		data = JSON.stringify({"cachedTripID": tripCookie});
	};

	await $.ajax({
		type: "post",
		url: "./tripPlanner_curTrip",
		data: data,
		contentType: "application/json",
		dataType: "json",
		success: (data)=>{
			if (data.response == "success") {
				trip = data.trip;
			} else {
				trip = null;
				errMsg = data.response;
				failSilently = true;//request did not fail but user does not have current trip
			};
		},
		error: (xhr, errStr, exc)=>{
			errMsg = errStr;
			trip = null;
		}
	});
	return new Promise<Trip_v2>((resolve,reject) => {
		if (trip != null) resolve(trip);
		else if (!failSilently) reject(new Error(errMsg));
		else reject(errMsg);
	});
};

export const getTripFromID = async (tripID:string) => {
	let trip:Trip_v2|null=null;
	let errMsg:string;

	let params:{tripID:string, trip?:Trip_cookieFormat};

	params = {
		tripID: tripID,
	};

	// let cookie:string = getCookie_base64("trip");
	// if (cookie != "") {
	// 	 params.trip = JSON.parse(cookie)
	// };


	await $.ajax({
		type: "post",
		url: "./getUserTrip",
		data: JSON.stringify(params),
		contentType: "application/json",
		dataType: "json",
		success: function(data){
			trip = data as Trip_v2;
		},
		error: (xhr, errStr, exc)=>{
			errMsg = errStr;
			trip = null;
		}
	});

	return new Promise<Trip_v2>((resolve,reject) => {
		if (trip != null) resolve(trip);
		else reject(new Error(errMsg));
	});
};

export const getPublishedTrip = async (tripID:string) => {
	let trip:Trip_v2|null=null;
	let errMsg:string;
	let success:boolean = false;

	await $.ajax({
		type: "get",
		url: `/publishedTrip?id=${tripID}`,
		contentType: "application/x-www-form-urlencoded",
		dataType: "json",
		success: (data) => {
			trip = data;
			success = true;
		},
		error: (xhr, errStr, exc)=>{
			errMsg = errStr;
			trip = null;
		}
	});

	return new Promise<Trip_v2>((resolve,reject) => {
		if (success) resolve(trip);
		else reject(Error(errMsg));
	});
};

export const send_tripPlanSearch = async (params:Trip_ReqFields_Regional | Trip_ReqFields_E2E | Trip_ReqFields_stopByStop) => {
	let trip:Trip_v2|null=null;
	let errMsg:string;
	await $.ajax({
		type:"post",
		url:"./tripPlanner",
		data: JSON.stringify(params),
		contentType: 'application/json',
		dataType:'json',
		success: (data) => {
			trip = data as Trip_v2;
			if (trip.directions == null) {
				trip = null;
			};
		},
		error: (xhr, errStr, exc)=>{errMsg = errStr;}

	});

	return new Promise<Trip_v2>((resolve,reject) => {
		if (trip != null) resolve(trip);
		else reject(Error(errMsg));
	});
};

export const send_tripPlanReDoSearch = async (trip:Trip_cookieFormat_v2) => {
	let newTrip:Trip_v2 = null;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./tripPlanner_refreshTrip",
		data: JSON.stringify(trip),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			newTrip = data as Trip_v2;
			if (newTrip.directions == null) {
				newTrip = null;
				errMsg = "Trip Missing Directions"
			};
		},
		error: (xhr,errStr,exc) => {
			newTrip = null;
			errMsg = errStr;
		}
	});

	return new Promise<Trip_v2>((resolve,reject) => {
		if (newTrip != null) resolve(newTrip);
		else reject(Error(errMsg));
	});
};

export const send_saveTrip = async (trip:Trip_v2, tripName:string,tripDescription:string, fromViewOnly:boolean) => {
	let success:boolean = false;
	let errMsg:string;
	let tripID:string;

	if (trip == null || trip == undefined) return;
	trip.name = tripName;
	trip.desc = tripDescription;

	let sendFormat:{
		trip:Trip_cookieFormat_v2,
		fromViewOnly:boolean
	} = {
		trip: getTrip_cachedForm(trip),
		fromViewOnly: fromViewOnly
	};

	await $.ajax({
		type: "post",
		url: "/saveTrip",
		data: JSON.stringify(sendFormat),
		contentType: "application/json",
		dataType: "json",
		success: (data)=>{
			if (data.status == "success") {
				success = true;
				tripID = data.tripID;
			} else {
				success = false;
				errMsg = data.tripID;
			}
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(tripID);
		else reject(Error(errMsg));
	});
};


export const send_reCalcLeg = async (trip:Trip_cookieFormat_v2, legIndex:number) => {
	let success:boolean = false;
	let response:Trip_v2;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/tripPlanner_reCalcLeg",
		data: JSON.stringify({trip:trip,legIndex:legIndex}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			response = data;
		},
		error: (xhr,errStr,exc)=>{
			success = false;
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<Trip_v2>((resolve, reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_addLegBySearch = async (searchQuery:string,legIndex:number, trip:Trip_cookieFormat_v2, autofill_type:string|null, autofill_val:string|null) => {

	let success:boolean = false;
	let response:Trip_v2;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "./tripPlanner_addLeg",
		data: JSON.stringify({searchQuery:searchQuery,legIndex:legIndex, trip:trip, autofill_type:autofill_type, autofill_val:autofill_val}),
		contentType: "application/json",
		dataType: "json",
		success: (data)=>{
			response = data as Trip_v2;
			success = true;
			if (response.directions == null) {
				errMsg = "Trip has no directions";
				success = false;
			};
		},
		error: (xhr,errStr,exc)=>{success = false;
			errMsg = errStr;
			success = false;
		}

	});

	return new Promise<Trip_v2>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});

};

export const send_removeStop_shaping_recalc = async (trip:Trip_v2, changedLegIndices:Array<number>, deletedLegIndices:Array<number>, legToRecalc:number) => {
	let response:Trip_v2;
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/removeStop_shaping",
		contentType: "application/json",
		dataType: "json",
		data: JSON.stringify({
			recalc: true,
			legToRecalc: legToRecalc,
			trip: getTrip_cachedForm(trip),
			changedLegIndices: changedLegIndices,
			deletedLegIndices: deletedLegIndices
		}),
		success: (data) => {
			response = data;
			success = true;
		},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	})

	return new Promise<Trip_v2>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_removeStop_shaping_noRecalc = async (trip:Trip_v2, changedLegIndices:Array<number>, deletedLegIndices:Array<number>) => {
	let response:{directions:any,stopListHTML:string};
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/removeStop_shaping",
		contentType: "application/json",
		dataType: "json",
		data: JSON.stringify({
			recalc: false,
			trip: getTrip_cachedForm(trip),
			changedLegIndices: changedLegIndices,
			deletedLegIndices: deletedLegIndices
		}),
		success: (data) => {
			response = data;
			success = true;
		},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	})

	return new Promise<{directions:any,stopListHTML:string}>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error(errMsg));
	});
};

export const send_removeStop_nonShaping = async (trip:Trip_v2, legIndex:number, stopIndex:number) => {
	let response:{directions:any,stopListHTML:string};
	let success:boolean = false;
	let errMsg:string;

	let forHTML_legs:Array<{
		lockedStops:Array<number>,
		clusters:Array<{
			selectedCamps:Array<Campground_Data>,
			fromUserQuery:boolean,
			clusterTitle:string,
			coords:{latitude:number,longitude:number}
		}>}> = extract_tripData_forHTML(trip);

		await $.ajax({
			type: "post",
			url: "./removeStop_nonShaping",
			data: JSON.stringify({
				tripLegData:{legs: forHTML_legs},
				legIndex:legIndex,
				stopIndex:stopIndex,
				queries:trip.queries,
				lockedLegs:trip.lockedLegs,
				filters: trip.filters,
				tripID: trip.tripID
			}),
			contentType: "application/json",
			dataType: "json",
			success: (data) => {
				response = data;
				success = true;
			},
			error: (xhr, errStr, exc) => {errMsg = errStr;}
		});

	return new Promise<{directions:any,stopListHTML:string}>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error("Trip Session Var Update Failed Or Could Not Get Directions"));
	});
};

export const send_curTripState_getHTML = async (trip:Trip_v2) => {
	let responseHTML:string;
	let success:boolean = false;
	let errMsg:string;

	let forHTML_legs:Array<{
		lockedStops:Array<number>,
		clusters:Array<{
			selectedCamps:Array<Campground_Data>,
			fromUserQuery:boolean,
			clusterTitle:string,
			coords:{latitude:number,longitude:number},
			POIs: Array<POI_Data>
		}>}> = extract_tripData_forHTML(trip);

	await $.ajax({
		type: "post",
		url: "./updateCurTrip_getHTML",
		data: JSON.stringify({
			trip_cachedForm: getTrip_cachedForm(trip),
			forHTML: forHTML_legs,
			tripID:trip.tripID
		}),
		contentType: "application/json",
		dataType: "html",
		success: (data) => {responseHTML = data; success = true;},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	})
};

export async function send_curTripState_getDirections_getHTML(trip:Trip_v2, showStaySelection:boolean) {
	let response:{directions:any,stopListHTML:string};
	let success:boolean = false;
	let errMsg:string;

	let forHTML_legs:Array<{
		lockedStops:Array<number>,
		clusters:Array<{
			selectedCamps:Array<Campground_Data>,
			fromUserQuery:boolean,
			clusterTitle:string,
			coords:{latitude:number,longitude:number}
		}>}> = extract_tripData_forHTML(trip);

	let to_send:Trip_sendUpdateGetDirectionsAndHTMLFormat_v2 = {
		trip: getTrip_cachedForm(trip),
		tripLegData: {
			legs: forHTML_legs
		},
		showStaySelection: showStaySelection,
		tripID: trip.tripID
	};
	await $.ajax({
		type: "post",
		url: "./updateCurTrip_getDirections_getHTML",
		data: JSON.stringify(to_send),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			response = data;
			success = true;
		},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	});

	return new Promise<{directions:any,stopListHTML:string}>((resolve,reject) => {
		if (success) resolve(response);
		else reject(Error("Trip Session Var Update Failed Or Could Not Get Directions"));
	});
};


export const get_campDataObj_withCluster_fromCampID = async (campID:number) => {
	let result:{selCamp:Campground_Data,altCamps:Array<Campground_Data>};
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/getCamp_fromCampID_withCluster",
		data: JSON.stringify({campID:campID}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			result = data;
			success = true;
		},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	})

	return new Promise<{selCamp:Campground_Data,altCamps:Array<Campground_Data>}>((resolve,reject) => {
		if (success) resolve(result);
		else reject(Error(errMsg));
	});
};

export const send_get_cluster = async (trip:Trip_v2, legIndex:number, stopIndex:number, radius:number, selStays_campIDs:Array<number>) => {
	let altStops:Array<Campground_Data>;
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/tripPlanner_getCluster",
		data: JSON.stringify({coords:trip.legs[legIndex].clusters[stopIndex].coords, radius:radius,selStays_campIDs:selStays_campIDs}),
		contentType: "application/json",
		dataType: "json",
		success: (data) => {
			success = true;
			altStops = data;
		},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	});

	return new Promise<Array<Campground_Data>>((resolve,reject) => {
		if (success) resolve(altStops);
		else reject(Error(errMsg));
	});
};

export const send_deleteCachedTrip = async (tripID:string) => {
	let success:boolean = false;
	let errMsg:string;

	await $.ajax({
		type: "post",
		url: "/deleteCachedTrip",
		data: JSON.stringify({tripID:tripID}),
		contentType: "application/json",
		success: (data) => {
			success = true;
		},
		error: (xhr, errStr, exc) => {errMsg = errStr;}
	});

	return new Promise<void>((resolve,reject) => {
		if (success) resolve();
		else reject(Error(errMsg));
	})
};


export const send_getPoiTabMenu = async () => {
	let success:boolean = false;
	let errMsg:string;
	let responseHTML:string;

	await $.ajax({
		type: "get",
		url: "/getPoiTabMenu",
		dataType: "html",
		success: (data)=>{
			success=true;
			responseHTML=data;
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};


export const get_poiPinPopup = async (poi:any) => {
	let success:boolean = false;
	let errMsg:string;
	let responseHTML:string;

	await $.ajax({
		type: "post",
		url: "/getPoiPinPopup",
		contentType: "application/json",
		data: JSON.stringify(poi),
		dataType: "html",
		success: (data)=>{
			success=true;
			responseHTML=data;
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};

export const get_campgroundPinPopup = async (campdata:any) => {
	let success:boolean = false;
	let errMsg:string;
	let responseHTML:string;

	await $.ajax({
		type: "post",
		url: "/getCampgroundPinPopup",
		contentType: "application/json",
		data: JSON.stringify(campdata),
		dataType: "html",
		success: (data)=>{
			success=true;
			responseHTML=data;
		},
		error: (xhr,errStr,exc)=>{
			errMsg = errStr;
			success = false;
		}
	});

	return new Promise<string>((resolve,reject) => {
		if (success) resolve(responseHTML);
		else reject(Error(errMsg));
	});
};
